import React, {useEffect, useState} from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

export const ProgramRoute = ({children}) => {
    const navigate = useNavigate();
    const program = useSelector((state) => state.program);
    const auth = useSelector((state) => state.auth);
    const [programAccess, setProgramAccess] = useState(false);

    useEffect(() => {
        if (auth === null) return;
        if (!auth?.isAdmin) {
            navigate('/manager/home');
        } else {
            setProgramAccess(true);
        }
    }, [auth]);
    
    if (!program || !programAccess) return null;

    return children;
}

export default ProgramRoute;